<template>
    <div class="TileList">
        <slot />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class TileList extends Vue {
    }
</script>
